import React from 'react';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { findOnArray } from 'utils/functions';
import { toastWarning } from 'utils/toast';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';

const CaixaBanco = ({
  drops,
  valor,
  contas,
  onSubmit,
  isCheque,
  isPagamento,
  isRecebimento,
}) => {
  const defaultValues = {
    valor: valor || '',
    forma_pagto_id: null,
    cxconta_id: Boolean(contas?.seqcaixa) ? contas?.cxconta_id : null,
  };
  const { control, handleSubmit } = useForm({ defaultValues });
  const drop = drops?.FormaDePagamento?.filter((f) => {
    if (isPagamento) {
      return f?.modulo !== 'VENDAS' && f?.modulo !== 'CHEQUES';
    } else if (isRecebimento) {
      return f?.modulo !== 'COMPRAS' && f?.modulo !== 'CHEQUES';
    } else if (isCheque) {
      return f?.modulo === 'CHEQUES';
    } else {
      return true;
    }
  });

  const onAddLancamento = (values) => {
    if (!Boolean(values?.forma_pagto_id)) {
      return toastWarning('Selecione uma forma de pagamento');
    }
    if (Boolean(values?.valor <= 0)) {
      return toastWarning('Valor inválido');
    }
    if (!Boolean(values?.cxconta_id)) {
      return toastWarning('Selecione uma conta');
    }
    const data = {
      ...values,
      forma_pagto: findOnArray(values?.forma_pagto_id, drop, 'label'),
    };
    onSubmit(data);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <InputMask name="valor" control={control} label="Valor" />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="forma_pagto_id"
          control={control}
          label="Forma de Pagamento"
          options={drop}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Dropdown
          name="cxconta_id"
          control={control}
          label="Conta"
          options={drops?.Cxconta}
          disabled={Boolean(contas?.seqcaixa)}
        />
      </Grid>
      <Grid item xs={12} textAlign="center">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit(onAddLancamento)}
        >
          Salvar
        </Button>
      </Grid>
    </Grid>
  );
};

export default CaixaBanco;
